
import * as actions from 'actions';
import pagingMaker from 'reducersMakers/pagingMaker';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('threadId',
  pagingMaker({
    fetchType: actions.MAIL_THREAD_MESSAGES_FETCH,
    fetchSuccessType: actions.MAIL_THREAD_MESSAGES_FETCH_SUCCESS,
    fetchErrorType: actions.MAIL_THREAD_MESSAGES_FETCH_ERROR,
    possiblePageUpdateType: actions.MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE
  })
);



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/paging/mailThreadMessages/byThreadId/reducer.js
 **/